import { action, makeObservable, observable } from "mobx";
import { RootStore } from "src/stores/RootStore";

export class InvoiceFormStore {
    rootStore: RootStore;

    isSaving: boolean = false;
    isSaveInvoiceWithoutDocumentModalDisplayed: boolean = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            isSaving: observable,
            isSaveInvoiceWithoutDocumentModalDisplayed: observable,
            setIsSaving: action,
            setIsSaveInvoiceWithoutDocumentModalDisplayed: action,
            saveForm: action,
            saveFormWithoutEvent: action,
            saveInvoiceAndAccountings: action,
            toggleDisplaySaveInvoiceWithoutDocumentModal: action,
            resetForm: action
        });
    }

    setIsSaving = (value: boolean) => {
        this.isSaving = value;
    };

    setIsSaveInvoiceWithoutDocumentModalDisplayed = (value: boolean) => {
        this.isSaveInvoiceWithoutDocumentModalDisplayed = value;
    };

    saveInvoiceAndAccountings = (closeEditModeAfterSave: boolean) => async (e: any) => {
        if (e) {
            e.preventDefault();
        }

        await this.saveFormWithoutEvent(closeEditModeAfterSave);
        await this.rootStore.invoiceStore.validateAndSaveInvoiceAccountingsWithoutEvent(closeEditModeAfterSave);
    };

    saveFormWithoutEvent = async (closeEditModeAfterSave: boolean = true) => {
        if (this.isSaving) {
            return;
        }

        const invoiceStore = this.rootStore.invoiceStore;

        if (this.isSaveInvoiceWithoutDocumentModalDisplayed) {
            this.setIsSaveInvoiceWithoutDocumentModalDisplayed(false);
        }

        this.setIsSaving(true);

        if (invoiceStore.isEditing) {
            const wasSuccessfullyValidated = invoiceStore.currentInvoice?.validate();

            if (wasSuccessfullyValidated) {
                await invoiceStore.saveCurrentInvoice(closeEditModeAfterSave);
                this.setIsSaving(false);
            } else {
                this.setIsSaving(false);
            }
        }

        this.setIsSaving(false);
    };

    saveForm =
        (closeEditModeAfterSave: boolean = true) =>
        async (e: any) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (this.isSaving) {
                return;
            }

            await this.saveFormWithoutEvent(closeEditModeAfterSave);
        };

    toggleDisplaySaveInvoiceWithoutDocumentModal = (e: any) => {
        e.preventDefault();
        e.stopPropagation(); // Stop the event from propagating further

        this.setIsSaveInvoiceWithoutDocumentModalDisplayed(!this.isSaveInvoiceWithoutDocumentModalDisplayed);
    };

    resetForm = async () => {
        await this.rootStore.invoiceStore.discardCurrentInvoiceChanges();
    };
}
